import React, { useEffect, useState } from 'react';
import { ApiClient } from './api-client';

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    async function verifySession() {
      const response = await ApiClient.checkSession();
      if (response.success) {
        setIsAuthenticated(true);
      } else {
        // Redirect to login if unauthenticated
        window.location.href = `${import.meta.env.VITE_WEBSITE_URL}/login`;
      }
    }
    verifySession();
  }, []);

  if (isAuthenticated === null) {
    // Show a loading state while verifying session
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-background">
        <div className="text-muted">Loading...</div>
      </div>
    );
  }

  // Session verified, render children
  return <>{children}</>;
}
